// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e96fff6e","952":"3ee46afc"}[chunkId] + ".chunk.js";
};